import React, { ComponentType, LazyExoticComponent, ReactNode, useContext } from 'react'; // Додаємо useEffect

import { ServiceCode } from '@/shared/types';

import { PrivateRouteWrapper } from '@/components/PrivateRouteWrapper';
import { SuspenseWithLoader } from '@/components/SuspenseWithLoader';

import { useRecaptchaBadge } from '@/hooks/useRecaptchaBadge';

import { ServicesContext } from '@/contexts/Services/ServicesContext';

interface ServiceWrapperProps {
  children: LazyExoticComponent<ComponentType<any>>;
  isPrivate?: boolean;
  serviceCode?: ServiceCode;
}

export const ServiceWrapper: React.FC<ServiceWrapperProps> = ({ children: LazyComponent, isPrivate, serviceCode }) => {
  const { getServiceByCode } = useContext(ServicesContext);
  const service = serviceCode ? getServiceByCode(serviceCode) : undefined;

  const needsCaptcha = !!service?.captcha_is_enabled;

  useRecaptchaBadge(needsCaptcha);

  let content: ReactNode = (
    <SuspenseWithLoader>
      <LazyComponent serviceCode={serviceCode} />
    </SuspenseWithLoader>
  );

  if (isPrivate) {
    content = <PrivateRouteWrapper>{content}</PrivateRouteWrapper>;
  }

  return content;
};
